var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-detail" },
    [
      _vm.$route.meta
        ? _c("div", { staticClass: "header" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      Object.keys(_vm.tableForm).length
        ? _c("Detail", {
            ref: "getTable",
            attrs: {
              tableData: _vm.tableForm,
              tableFormAttrs: _vm.tableFormAttrs,
              filterDataRules: _vm.filterDataRules,
              merchantLogo: _vm.tableForm.merchantLogo,
              formLabelWidth: "98px",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }